"use strict";

import "./VehicleActivityTimeline.css";
import React from "react";

import dispatcher from "./../../dispatcher";

import vehicleActivityStore from "./../../store/vehicleActivities";

import vehicleActivityUtils from "./../../utils/vehicleActivity";

import Card from "vwa/components/Card";
import lang from "vwa/lang";
import EEP from "vfu/EEP";

import Section from "./Section";
import SectionCard from "./SectionCard";

const ALL = Symbol();
const ANY = Symbol();

export default class VehicleActivityTimeline extends React.Component {
	
	constructor(props){
		super(props);
		this.initState();
		this.eep = new EEP();
		this.setStoreListeners();
	}
	
	initState(){
		this.state = Object.assign({
			fixedData: []
		}, this.getStoreDependentState());
	}
	
	getStoreDependentState() {
		const resolvedActivity = vehicleActivityUtils.getResolvedVehicleActivity(this.props.vehicleId);
		const activityDescriptor = vehicleActivityStore.get(this.props.vehicleId);
		
		return {
			from: activityDescriptor ? activityDescriptor.from : null,
			to: activityDescriptor ? activityDescriptor.to : null,
			summary: resolvedActivity ? resolvedActivity.summary : null,
			sections: resolvedActivity ? resolvedActivity.sections : null,
			pinnedSections: activityDescriptor ? Array.from(activityDescriptor.pinnedSections) : []
		};
	}
		
	setStoreListeners(){
		this.eep.on(vehicleActivityStore, "insert", descriptors => {
			const descriptor = descriptors.find(d => d.vehicle == this.props.vehicleId);
			if (descriptor && !descriptor.pending) {
				this.setState(this.getStoreDependentState());
			}
		});
		this.eep.on(vehicleActivityStore, "update", descriptor => {
			if (descriptor.vehicle == this.props.vehicleId  && !descriptor.pending) {
				this.setState(this.getStoreDependentState());
			}
		});
		this.eep.on(vehicleActivityStore, "remove", vehicleIds => {
			if (vehicleIds.find(id => id == this.props.vehicleId))
				this.setState(this.getStoreDependentState());
		});
	}
		
	componentWillUnmount() {
		this.eep.close();
	}
	
	shouldComponentUpdate(_, nextState) {
		if (nextState.from !== this.state.from || nextState.to !== this.state.to) {
			return true;
		}
		if (nextState.fixedData.some(fd => !this.state.fixedData.includes(fd)) ||
			this.state.fixedData.some(fd => !nextState.fixedData.includes(fd))) {
			return true;
		}
		if (nextState.pinnedSections.some((ps, i) => ps !== this.state.pinnedSections[i])) {
			return true;
		}
		return false;
	}
	
	getSectionsCumulativePinnedStatus(how) {
		if (!this.state.sections)
			return;
		
		const activeSectionsPinnedStatus = this.state.pinnedSections.filter((_, i) => this.state.sections[i].active);
		if (how === ALL)
			return activeSectionsPinnedStatus.every(_ => _);
		else if (how === ANY)
			return activeSectionsPinnedStatus.some(_ => _);
		
		return false;
	}
	
	handlePinAll(value) {
		if (!this.state.sections)
			return;
		
		dispatcher.dispatch(
			"pinVehicleActivitySection",
			this.props.vehicleId,
			this.state.sections.map((_, i) => i),
			value
		);
	}
	
	handleHighlightAll(value) {
		if (!this.state.sections)
			return;
		
		dispatcher.dispatch(
			"highlightVehicleActivitySection",
			this.props.vehicleId,
			this.state.sections.map((_, i) => i),
			value
		);
	}
	
	handleOnAddressClick(section, which) {
		if (!section[which].position)
			return;
		dispatcher.dispatch("setMap", {
			center:	section[which].position,
			zoom:	16
		});
	}
	
	handleFixData(which) {
		const prevFixedData = Array.from(this.state.fixedData);
		const index = prevFixedData.indexOf(which);
		if (index > -1) {
			prevFixedData.splice(index, 1);
		} else {
			prevFixedData.push(which);
		}
		this.setState({
			fixedData: prevFixedData
		});
	}
	
	renderSummary() {
		if (!this.state.summary)
			return null;
		
		const summary = this.state.summary;
		
		return (
			<div className="SummaryContainer">
				<div className="LeftPadding"></div>
				<div>
					<SectionCard
						section={summary}
						isSummary={true}
						fixedData={this.state.fixedData}
						pinned={this.getSectionsCumulativePinnedStatus(ANY)}
						pinnedAll={this.getSectionsCumulativePinnedStatus(ALL)}
						onPinChange={value => this.handlePinAll(value)}
						onClick={() => {
							vehicleActivityUtils.focusOnVehicleActivity(this.props.vehicleId);
							dispatcher.dispatch("selectVehicleActivityRoute", this.props.vehicleId);
						}}
						onAddressClick={which => this.handleOnAddressClick(summary, which)}
						onMouseEnter={() => this.handleHighlightAll(true)}
						onMouseLeave={() => this.handleHighlightAll(false)}
						onFixData={which => this.handleFixData(which)}
					/>
				</div>
			</div>
		);
	}
	
	renderSection(section, count, sectionNumber) {
		return (
			<Section
				key={count}
				section={section}
				isFirst={count===0}
			>
				{section.active ? (
					<SectionCard
						key={count}
						section={section}
						sectionNumber={sectionNumber}
						fixedData={this.state.fixedData}
						pinned={this.state.pinnedSections[count]}
						onPinChange={value => dispatcher.dispatch("pinVehicleActivitySection", this.props.vehicleId, [count], value)}
						onClick={() => {
							vehicleActivityUtils.focusOnVehicleActivity(this.props.vehicleId, section.start.time.getTime(), section.end.time.getTime());
							dispatcher.dispatch("selectVehicleActivityRoute", this.props.vehicleId, section.start.time.getTime(), section.end.time.getTime());
						}}
						onAddressClick={which => this.handleOnAddressClick(section, which)}
						onMouseEnter={() => dispatcher.dispatch("highlightVehicleActivitySection", this.props.vehicleId, [count], true)}
						onMouseLeave={() => dispatcher.dispatch("highlightVehicleActivitySection", this.props.vehicleId, [count], false)}
						onFixData={which => this.handleFixData(which)}
					/>
				) : null}
			</Section>
		);
	}
	
	renderSections() {
		if (!this.state.sections || (this.state.sections.length == 1 && !this.state.sections[0].active))
			return null;
		
		return this.state.sections.map((section, i) => this.renderSection(section, i, vehicleActivityUtils.getActiveSectionNumberOfSectionIndex(this.props.vehicleId, i)));
	}
	
	render(){
		return (
			<div className="VehicleActivityTimeline">
				<div>
					{this.renderSummary()}
					{this.renderSections()}
				</div>
			</div>
		);
	}
	
}

VehicleActivityTimeline.propTypes = {
	vehicleId: React.PropTypes.string
};

VehicleActivityTimeline.defaultProps = {
	vehicleId: null
};


// WEBPACK FOOTER //
// ./src/view/VehicleActivityTimeline/VehicleActivityTimeline.jsx